import {APP_URL, getRnd} from 'lib/utils/urlUtils';
import {callAsyncBackend} from 'lib/call-authorized-backend'

const historyURL = `${APP_URL}/service/che_data_service/rest/history`;

export const findReportsByFormData = async (formData) => {
    const vin = formData.get('vin') || '';
    const engineDisplacement = formData.get('engineDisplacement') || '';
    const year = formData.get('year') || '';

    const selectedDatabases = [];

    ['ahiAbroad', 'ahiLocal', 'ahiUsa', 'aon'].forEach(name => {
        const value = formData.get(name);
        if (value) selectedDatabases.push(value);
    });
    return await findReports(vin, engineDisplacement, year, selectedDatabases);
};

const findReports = async (vin, engineDisplacement, year, selectedDatabases) => {
    const searchParams = new URLSearchParams();
    searchParams.set('vin', vin);
    searchParams.set('engine_cc', engineDisplacement);
    searchParams.set('firstRegistrationDate', year);
    searchParams.set('subscriptions', selectedDatabases.join(','));
    searchParams.set('rnd', getRnd());
    return await findReportsBySearchParams(searchParams);
};

export const findReportsBySearchParams = async (searchParams) => {
    const callBackend = async () => {
        const token = localStorage.getItem('token');
        const url = `${historyURL}?${searchParams}`;
        return await fetch(url, {
            headers: {
                'Accept': 'application/json',
                'Token': token,
            },
        });
    }

    const handleAsyncSuccessResponse = async (response) => {
        const data = await response.json();
        return {
            requestCompleted: true,
            vin: searchParams?.get('vin'),
            data: data,
        }
    };

    const handleAsyncErrorResponse = async () => {
        return {
            requestCompleted: true,
        }
    }

    return callAsyncBackend(callBackend, handleAsyncSuccessResponse, handleAsyncErrorResponse);
};
